<template>
  <div class="container page" style="width: 100%; min-height: 100vh; background: #f7f8fa;">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#ff" @click="back()"/>
      </template>
    </van-nav-bar>

    <!-- 已绑定银行卡展示 -->
    <div class="bank-card" v-if="is_bind">
      <!-- 卡片背景装饰 -->
      <div class="card-bg">
        <div class="card-pattern"></div>
      </div>
      
      <!-- 卡片内容 -->
      <div class="card-content">
        <div class="bank-logo">
          <van-icon name="bank-card-o" size="40PX" color="#fff" />
        </div>
        
        <div class="bank-info">
          <div class="bank-name">{{ bankInfo.bankinfo }}</div>
          <div class="bank-number">**** **** **** {{ bankInfo.bankid ? bankInfo.bankid.slice(-4) : '' }}</div>
        </div>

        <div class="card-details">
          <div class="detail-row">
            <span class="detail-label">{{$t('setting.band_name')}}</span>
            <span class="detail-value">{{ bankInfo.bankinfo }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">{{$t('setting.band_account')}}</span>
            <span class="detail-value">{{ bankInfo.bankid }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">{{$t('setting.branch_name')}}</span>
            <span class="detail-value">{{ bankInfo.bankfenhang || '' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">{{$t('setting.branch_code')}}</span>
            <span class="detail-value">{{ bankInfo.fhnumber || '' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">{{$t('setting.username')}}</span>
            <span class="detail-value">{{ bankInfo.username || userInfo.name }}</span>
          </div>
        </div>

        <div class="bind-status">
          <van-icon name="checked" color="#4CAF50" size="16PX" />
          <span>{{$t("setting.bindinged")}}</span>
        </div>
      </div>
    </div>

    <!-- 未绑定银行卡提示 -->
    <div class="empty-state" v-else>
      <van-icon name="credit-pay" size="80PX" color="#ccc" />
      <p class="empty-text">{{$t("setting.bind_bank_tip")}}</p>
      <van-button class="bind-btn" color="linear-gradient(90deg, #ee392f, #f4562a)" @click="toBindCard()">
        {{$t("setting.add_bank")}}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind: false,
      bankInfo: {},
      userInfo: {}
    };
  },
  methods: {
    back() {
      this.$router.push({path: '/Mine'});
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
            this.bankInfo = res.data.info;
          } else {
            this.is_bind = false;
            // 不自动跳转，展示未绑定状态
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    toBindCard() {
      if (!this.userInfo.name) {
        this.$router.push("Setname");
        this.$toast(this.$t("setting.set_name_bank"));
        return true;
      } else if (!this.userInfo.paypassword) {
        this.$router.push({path: '/BindCard'});
        return true;
      } else {
        this.$router.push({path: '/BindCard'});
      }
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
}

.nav-bar {
  background: #8600ff;
  :deep(.van-nav-bar__title) {
    color: #333;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #333;
  }
}

/* 银行卡卡片 */
.bank-card {
  position: relative;
  width: 90%;
  margin: 30PX auto;
  border-radius: 16PX;
  overflow: hidden;
  box-shadow: 0 8PX 24PX rgba(238, 57, 47, 0.2);
  background: linear-gradient(135deg, #ee392f 0%, #f4562a 50%, #ff6b35 100%);
}

/* 背景装饰图案 */
.card-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.card-pattern {
  position: absolute;
  width: 200PX;
  height: 200PX;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  top: -80PX;
  right: -80PX;
}

.card-pattern::after {
  content: '';
  position: absolute;
  width: 120PX;
  height: 120PX;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  bottom: -40PX;
  left: -40PX;
}

.card-content {
  position: relative;
  padding: 25PX 20PX;
  color: #fff;
  z-index: 10;
}

/* 银行Logo和卡号 */
.bank-logo {
  display: flex;
  align-items: center;
  margin-bottom: 20PX;
}

.bank-info {
  margin-bottom: 20PX;
}

.bank-name {
  font-size: 18PX;
  font-weight: 700;
  margin-bottom: 8PX;
}

.bank-number {
  font-size: 14PX;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 2PX;
}

/* 详细信息 */
.card-details {
  background: rgba(255, 255, 255, 0.12);
  border-radius: 12PX;
  padding: 12PX 15PX;
  margin-bottom: 15PX;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8PX 0;
  border-bottom: 1PX solid rgba(255, 255, 255, 0.15);
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 13PX;
  color: rgba(255, 255, 255, 0.8);
}

.detail-value {
  font-size: 13PX;
  font-weight: 500;
  color: #fff;
}

/* 绑定状态 */
.bind-status {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5PX;
  font-size: 13PX;
  color: rgba(255, 255, 255, 0.9);
}

/* 未绑定状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80PX 30PX;
  background: #fff;
  margin: 30PX auto;
  width: 90%;
  border-radius: 16PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
}

.empty-text {
  font-size: 15PX;
  color: #999;
  margin: 20PX 0 30PX;
  text-align: center;
}

.bind-btn {
  width: 80%;
  line-height: 40PX;
  height: 40PX;
  border-radius: 25PX;
  font-size: 15PX;
  font-weight: 600;
  color: #fff;
}
::v-deep  .van-button__content{
	height: 40PX;
	line-height: 40PX;
}
</style>